<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.memberShip.list") }}</h1>
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="10">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input
            :placeholder="$locale('form.plsEnterYourName')"
            v-model="filter.name"
            @keyup.enter.native="filter_fn"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn" style="cursor: pointer;"></i>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="filter_fn">{{
              $locale("global.confirm2")
            }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="14" class="search-item ta-r">
        <el-button class="egl-btn-yellow" @click="$router.push('/memberShip-list/create')">{{ $locale("cinemaWebsite.custom.create") }}</el-button>
      </el-col>
    </el-row>
    <!-- table -->
    <el-table
      :data="tableData"
      class="egl-table list-table"
      stripe
      @filter-change="filterChange_fn"
    >
      <el-table-column prop="name" :label="$locale('global.name')" align="center"></el-table-column>
      <el-table-column prop="validPeriod" :label="$locale('membership.validPeriod')" align="center">
        <template slot-scope="scope">
          {{ scope.row.timeLimit ? `${scope.row.periodCount}${scope.row.periodType === "month" ? "月期間" : "年"}` : "期間なし" }}
        </template>
      </el-table-column>
      <el-table-column prop="membershipFree" :label="$locale('report.cinemaDaily.membershipFree')" align="center">
        <template slot-scope="scope">
          {{ priceFormatter(scope.row.joinFee) + "円" }}
        </template>
      </el-table-column>
      <el-table-column prop="automaticUpdate" :label="$locale('membership.automaticUpdate')" align="center">
        <template slot-scope="scope">
          {{ scope.row.autoRenew ? "あり" : "なし" }}
        </template>
      </el-table-column>
      <el-table-column prop="paymentMethod" :label="$locale('membership.membershipFeePaymenMethod')" align="center">
        <template slot-scope="scope">
          {{ (paymentTypeList.find(item => item.value === scope.row.paymentType) || {}).label }}
        </template>
      </el-table-column>
      <el-table-column prop="" :label="$locale('membership.window-renewal-fee')" align="center">
        <template slot-scope="scope">
          {{ priceFormatter(scope.row.renewOfflineAdditionalFee) + "円" }}
        </template>
      </el-table-column>
      <el-table-column prop="updateFee" :label="$locale('membership.internet-update-fee')" align="center">
        <template slot-scope="scope">
          {{ priceFormatter(scope.row.renewOnlineAdditionalFee) + "円" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        :label="$locale('global.status')"
        align="center"
        :filters="statusArr"
        :filtered-value="[]"
        column-key="status"
      >
        <template slot-scope="scope">
          {{  (statusArr.find(item => item.value === scope.row.memberShipStatus) || {}).text }}
        </template>
      </el-table-column>
      <el-table-column :label="$locale('global.control')" min-width="180" align="center">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="$router.push(`/memberShip-list/update/${scope.row.id}`)">{{ $locale("global.edit") }}</a>
            <template v-if="!scope.row.default">
              <el-divider direction="vertical"></el-divider>
              <a @click="remove_fn(scope.row.id, scope.$index)">{{ $locale("global.delete") }}</a>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CommPagination
      :total="count"
      :curPage="currentPage"
      @current-change="pageChange"
      :pageSize="20"
      style="height: 34px;margin-right: 0;"
    />
  </div>
</template>
<script>
import CommPagination from "@/components/common/CommPagination";

import { getMemberShipListService, getMemberShipDetailService, removeMemberShipService } from "@/helpers/service/api/membership";
import { getPaymentType, getMemberShipStatus, priceFormatter } from "@/assets/js/membership";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      filter: {
        name: "",
      },
      statusArr: getMemberShipStatus(),
      paymentTypeList: getPaymentType(),
      tableData: [],
      count: 0,
      currentPage: 0,
      filters: [],
      priceFormatter,
    }
  },
  created() {
    this.getList();
  },
  methods: {
    filter_fn() {
      this.currentPage = 0
      this.getList();
    },
    filterChange_fn(filters) {
      this.filters = filters.status
      this.currentPage = 0
      this.getList();
    },
    showDetailDailog() {},
    pageChange(value) {
      if (!value) { return; }
      this.currentPage = value - 1;
      this.getList();
    },
    getList() {
      getMemberShipListService({
        brandId: window.localStorage.getItem("brandId"),
        ...this.filters.length > 0 ? {
          memberShipStatus: this.filters
        } : {},
        ...this.filter.name ? { name: this.filter.name } : {},
        page: this.currentPage, 
        pageSize: 20,
      }).then(res => {
        if (res.data) {
          this.count = res.data.count;
          this.tableData = res.data.data
        } else {
          this.tableData = []
        }
      })
    },
    remove_fn(id, index) {
      const that = this;
      let { name } = that.tableData[index];
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        removeMemberShipService({ id }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.deleteSuccessfully"), callback: () => {
              this.currentPage = 0;
              this.getList();
            }});
          }
        })
      })
    },
  },
  components: {
    CommPagination
  }
}
</script>
<style lang="less" scoped></style>